import Utils3D from 'shared/libraries/mwc/3d/utils/utils3D';
import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import GlobalDefs from '../../../globalDefs.js';
import AssetCacher, { ASSET_TYPE } from '../assetCacher.js';

export default class NodeLoadMaterial extends Node
{
	constructor(pParent)
	{
		super(pParent);

		const pAssetProvider = this.getGraph().getAssetProvider();
		const pMaterialChoices = pAssetProvider.getMaterialList();

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		let defaultChoice = GlobalDefs.g_strNoneKey;
		this.addInput(PARAM_TYPE.DROPDOWN_MATERIAL, 'material', defaultChoice, { dropdownOptions: pMaterialChoices });
		this.addInput(PARAM_TYPE.BOOLEAN, 'use_diffuse', false);
		this.addInput(PARAM_TYPE.COLOR, 'diffuse', {r: 0.5, g: 0.0, b: 0.5});

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}
	
	getType()
	{
		return 'loadMaterial';
	}

	getIsLoading()
	{
		return AssetCacher.getInstance().getIsNodeLoading(this);
	}

	getReferencedAssetIds(resMapOut)
	{
		let assetKey = this.getLastInputResult('material');
		if(assetKey && assetKey != GlobalDefs.g_strNoneKey && resMapOut['materialIds'].indexOf(assetKey) < 0)
			resMapOut['materialIds'].push(assetKey);
	}

	applyMaterialFromMesh(pTargetMeshList, pSourceMesh, inputValues)
	{
		let pSrcMaterial = pSourceMesh.material.subMaterials ? pSourceMesh.material.subMaterials[0] : pSourceMesh.material;
		if(inputValues['use_diffuse']) {
			const inputDiffuse = inputValues['diffuse'];
			const diffuseColor = new BABYLON.Color4(inputDiffuse.r, inputDiffuse.g, inputDiffuse.b, 1.0);
			const newName = `${pSrcMaterial.name}_${diffuseColor.toString()}`
			pSrcMaterial = pSrcMaterial.clone();
			AssetCacher.getInstance().applyColorMaterialParams(pSrcMaterial, diffuseColor);
			pSrcMaterial.name = newName;
			if(pSrcMaterial.albedoTexture !== undefined)
				pSrcMaterial.albedoTexture = null;
			else
				pSrcMaterial.diffuseTexture = null;
			this.onMaterialCreated(pSrcMaterial);
		}

		for(let pMesh of pTargetMeshList)
		{
			if(!pMesh.material)
			{
				pMesh.material = pSrcMaterial;
				if(pSrcMaterial.diffuseColor)
				{
					if(!pSrcMaterial.diffuseTexture)
						pMesh.material.emissiveColor = pMesh.material.diffuseColor.clone().scale(0.85);
					else
						pMesh.material.emissiveColor = new BABYLON.Color3(0.30, 0.30, 0.30);
				}

				this.onMaterialAssigned(pMesh);
				continue;
			}

			let pTargetMaterial = pMesh.material.subMaterials ? pMesh.material.subMaterials[0] : pMesh.material;
			Utils3D.assignTexturesAndColorsOnto(pTargetMaterial, pSrcMaterial);

			pTargetMaterial.origName = pSrcMaterial.origName;
			this.onMaterialAssigned(pMesh);
		}
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let strSelectedKey = inputValues['material'];
		let pGeoListIn = inputValues['geo']
		if(!strSelectedKey || strSelectedKey.length === 0 || !pGeoListIn || pGeoListIn.length === 0 || strSelectedKey === GlobalDefs.g_strNoneKey)
			return pGeoListIn;

		let pCachedMesh = AssetCacher.getInstance().getCachedAsset(ASSET_TYPE.MATERIAL, strSelectedKey, scene, undefined, this);
		if(pCachedMesh)
		{
			this.applyMaterialFromMesh(pGeoListIn, pCachedMesh, inputValues);
			return pGeoListIn;
		}

		const pAssetProvider = this.getGraph().getAssetProvider();
		const pMaterialInfo = pAssetProvider.getMaterial(inputValues['material']);

		let strFullPath;
		if(pMaterialInfo)
			strFullPath = pMaterialInfo.file;
		if(!strFullPath || strFullPath == '')
			return pGeoListIn;

		AssetCacher.getInstance().getBabylonAsset(this, ASSET_TYPE.MATERIAL, strSelectedKey, scene, undefined,
			() => {	this.getGraph().onStartLoadingAsset(); },
			(pMesh) => 
			{
				if(pMesh)
					this.applyMaterialFromMesh(pGeoListIn, pMesh, inputValues);

				this.markDirty();
				this.getGraph().onFinishLoadingAsset();
			}
		);

		return pGeoListIn;
	}
}